import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'contents',
    gap: '1rem',
  },
  textField: {
    width: '90%',
  },
  textArea: {
    maxWidth: '95%',
    minWidth: '95%',
  },
}));

export default useStyles;
